import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  QUINTS_API_URLS_PERMISSIONS,
  QUINTS_API_URLS_ROUTE_NAME,
  TRANSLATION_GROUPS_OF_QUINTS_API,
} from '@modules/quints-api/constants';
import { getTranslationKeys } from '@modules/quints-api/translations';
import { ADMIN_SETTINGS_MENU_ITEM, TRANSLATION_GROUP_SIDEBAR } from '@modules/sidebar/constants';

export class QuintsApiModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: QUINTS_API_URLS_ROUTE_NAME,
      path: 'quints-api',
      permission: QUINTS_API_URLS_PERMISSIONS.SHOW,
      component: () => import('@modules/quints-api/pages/QuintsApiPage/QuintsApiPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_SETTINGS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'SYSTEM_SETTINGS_QUINTS_API'),
      to: {
        name: QUINTS_API_URLS_ROUTE_NAME,
      },
      permission: QUINTS_API_URLS_PERMISSIONS.SHOW,
      id: QUINTS_API_URLS_ROUTE_NAME,
      order: 50,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUPS_OF_QUINTS_API, getTranslationKeys);
  }
}
